/**
 * Phase 3 stub: Google / Apple social login buttons (disabled until OAuth credentials exist).
 * Schema: platform_oauth_identities (migration 20260806).
 */
import { useTranslation } from '@/i18n/useTranslation'

export function SocialLoginStub({ context }: { context: 'signup' | 'login' }) {
  const { t } = useTranslation('common')
  const label =
    context === 'signup' ? t('marketing.signup.googleSignup') : t('marketing.signup.googleContinue')
  return (
    <div className="mt-6">
      <div className="relative">
        <div className="absolute inset-0 flex items-center" aria-hidden>
          <div className="w-full border-t border-slate-200" />
        </div>
        <div className="relative flex justify-center text-xs">
          <span className="bg-white px-2 text-slate-500">{t('marketing.signup.orContinueWith')}</span>
        </div>
      </div>
      <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
        <button
          type="button"
          disabled
          title={t('marketing.signup.socialComingSoon')}
          className="inline-flex cursor-not-allowed items-center justify-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 text-sm font-medium text-slate-400"
        >
          <GoogleGlyph />
          {label}
        </button>
        <button
          type="button"
          disabled
          title={t('marketing.signup.socialComingSoon')}
          className="inline-flex cursor-not-allowed items-center justify-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 text-sm font-medium text-slate-400"
        >
          <AppleGlyph />
          Apple
        </button>
      </div>
      <p className="mt-2 text-center text-xs text-slate-400">{t('marketing.signup.socialComingSoon')}</p>
    </div>
  )
}

function GoogleGlyph() {
  return (
    <svg className="h-4 w-4" viewBox="0 0 24 24" aria-hidden>
      <path
        fill="currentColor"
        d="M21.35 11.1h-9.17v2.96h5.3c-.23 1.25-.96 2.3-2.04 3.01v2.5h3.3c1.93-1.78 3.04-4.4 3.04-7.5 0-.72-.07-1.42-.2-2.07z"
        opacity=".35"
      />
      <path
        fill="currentColor"
        d="M12.18 22c2.76 0 5.08-.91 6.77-2.48l-3.3-2.5c-.92.62-2.1.98-3.47.98-2.67 0-4.93-1.8-5.74-4.22H3.05v2.58C4.73 19.7 8.18 22 12.18 22z"
        opacity=".55"
      />
      <path
        fill="currentColor"
        d="M6.44 13.78A5.98 5.98 0 0 1 6.12 12c0-.62.11-1.22.32-1.78V7.64H3.05A9.99 9.99 0 0 0 2.18 12c0 1.61.39 3.14 1.07 4.5l3.19-2.72z"
        opacity=".75"
      />
      <path
        fill="currentColor"
        d="M12.18 5.98c1.5 0 2.84.52 3.9 1.53l2.92-2.92C17.25 2.9 14.93 2 12.18 2 8.18 2 4.73 4.3 3.05 7.64l3.39 2.58c.81-2.42 3.07-4.24 5.74-4.24z"
        opacity=".9"
      />
    </svg>
  )
}

function AppleGlyph() {
  return (
    <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M16.37 12.63c.03 3.2 2.81 4.27 2.84 4.28-.02.07-.44 1.52-1.46 3.01-.88 1.29-1.8 2.57-3.24 2.6-1.42.02-1.88-.84-3.5-.84-1.63 0-2.14.82-3.49.87-1.4.05-2.47-1.4-3.37-2.68-1.83-2.65-3.23-7.48-1.35-10.75.93-1.63 2.6-2.66 4.41-2.69 1.38-.03 2.68.93 3.5.93.83 0 2.38-1.15 4.01-.98.68.03 2.6.28 3.83 2.08-.1.06-2.29 1.34-2.18 4.17zM14.6 4.4c.72-.87 1.21-2.08 1.08-3.29-1.04.04-2.3.7-3.05 1.57-.67.77-1.26 2-1.1 3.18 1.17.09 2.35-.59 3.07-1.46z" />
    </svg>
  )
}
